import styled from 'styled-components';

export const FeatureWrapper = styled.div`
  section {
    border: none;
  }
`;
